<style>
  .red-button {
    [tuiWrapper][data-appearance='primary'] {
      background-color: #ff4b5f;
    }
  }
</style>

@let errorText = $errorText();

@switch (currentViewStep) {
  @case (ViewStepsType.Problems) {
    <ng-container *ngTemplateOutlet="problems"></ng-container>
  }
  @case (ViewStepsType.Reason) {
    <ng-container *ngTemplateOutlet="reason"></ng-container>
  }
}

<ng-template #problems>
  <div class="goods-problems-list-container" [innerHTML]="problemsText"></div>
  <div class="flex justify-end mt-4 md:gap-4">
    <button
      tuiButton
      class="grow md:grow-0 red-button"
      [style.border-radius.rem]="100"
      type="button"
      size="s"
      (click)="currentViewStep = ViewStepsType.Reason"
    >
      {{
        'request_form.goods.forcibly_modal.button_complete_forcibly' | translate
      }}
    </button>
    <button
      tuiButton
      class="grow md:grow-0"
      appearance="outline"
      [style.border-radius.rem]="100"
      type="button"
      size="s"
      (click)="clearSelfState()"
    >
      {{
        'request_form.goods.forcibly_modal.button_complete_forcibly_cancel'
          | translate
      }}
    </button>
  </div>
</ng-template>

<ng-template #reason>
  <div [formGroup]="formGroup">
    <div class="typo-body-m font-extrabold">
      {{ 'request_form.goods.forcibly_modal.reason_step_header' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <textarea
          placeholder="{{
            'request_form.goods.forcibly_modal.reason_step_placeholder'
              | translate
          }}"
          tuiTextarea
          [formControlName]="FormFields.Reason"
          [min]="6"
          [max]="12"
        ></textarea>
      </tui-textfield>
      @if (reasonField.touched && reasonField.errors?.['required']) {
        <tui-error
          class="ml-2"
          [error]="
            'request_form.goods.forcibly_modal.reason_step_error_required'
              | translate
          "
        ></tui-error>
      }
      @if (errorText) {
        <tui-error [error]="errorText"></tui-error>
      }
    </div>

    <div class="flex justify-end mt-4 md:gap-4">
      <button
        tuiButton
        class="grow md:grow-0"
        appearance="outline"
        [style.border-radius.rem]="100"
        type="button"
        size="s"
        (click)="clearSelfState()"
      >
        {{
          'request_form.goods.forcibly_modal.button_complete_forcibly_reason_cancel'
            | translate
        }}
      </button>
      @if (!errorText) {
        <button
          tuiButton
          class="w-1/2 md:w-auto"
          appearance="primary"
          [style.border-radius.rem]="100"
          type="button"
          size="s"
          (click)="completeForcibly$.next()"
          [ngClass]="
            formGroup.invalid ? 'cursor-not-allowed' : 'cursor-pointer'
          "
          [disabled]="formGroup.invalid"
        >
          {{
            'request_form.goods.forcibly_modal.button_complete_forcibly_reason_confirm'
              | translate
          }}
        </button>
      }
    </div>
  </div>
</ng-template>
